import axios from 'axios';

const API_BASE = process.env.REACT_APP_MARKET_API_BASE_URL || '/api';
const API_TIMEOUT = Number(process.env.REACT_APP_API_TIMEOUT || 10000);

const api = axios.create({
  baseURL: API_BASE,
  timeout: API_TIMEOUT,
});

// Добавляем интерцептор для авторизации
api.interceptors.request.use(config => {
  const token = getAuthToken();
  if (token) {
    config.headers['api_key'] = token;
  }
  return config;
});

export const getBalance = async () => {
  try {
    const response = await api.get('/account/balance');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createDeposit = async (currency) => {
  try {
    const response = await api.post('/transactions/deposit', {
      currency
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createWithdraw = async (currency, amount, address) => {
  try {
    const response = await api.post('/transactions/withdraw', {
      currency,
      amount,
      address
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createBid = async (bidData) => {
  try {
    const response = await api.post('/bid', bidData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Вспомогательная функция для получения токена
const getAuthToken = () => {
  // Checking for Safari
  const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };
  if (isSafari()) {
    return localStorage.getItem("authToken");
  }

  const cookies = document.cookie.split(';');
  const tokenCookie = cookies.find(c => c.trim().startsWith('token='));
  return tokenCookie ? tokenCookie.split('=')[1] : null;
};

export const getTransactionsHistory = async (filters = {}) => {
  try {
    const response = await api.get('/transactions/transfers', {
      params: filters
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTradesHistory = async (filters = {}) => {
  try {
    const response = await api.get('/bids', {
      params: filters
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cancelTrade = async (tradeId) => {
  try {
    console.log(`/market/${tradeId}`);
    const response = await api.delete(`/market/${tradeId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
